// extracted by mini-css-extract-plugin
export default {"wrap":"Forecast_wrap__Ew7ge","day":"Forecast_day__YLkGj","desc":"Forecast_desc__ZpSpj"};